/* eslint-disable import/prefer-default-export */
export const SetGoogleMaps = "SetGoogleMaps";
export const SetGoogleMapsMarkerStatus = "SetGoogleMapsMarkerStatus";
export const SetGoogleMapsSucess = "SetGoogleMapsSucess";
export const SetGoogleMapsError = "SetGoogleMapsError";
